import { List } from 'immutable';
import { lruMemoize } from 'reselect';

import {
    isResourceLoading,
    getResourceTotal,
    getResourcePage,
    getResourcePerPage,
} from './common';

const isRedirectRecordsLoading = lruMemoize(isResourceLoading);
const getRedirectRecordsTotal = getResourceTotal;
const getRedirectRecordsPage = getResourcePage;
const getRedirectRecordsPerPage = getResourcePerPage;
const getRedirectRecords = lruMemoize(
    (data) => data.get('redirect_records', List()),
);

export {
    isRedirectRecordsLoading,
    getRedirectRecordsTotal,
    getRedirectRecordsPage,
    getRedirectRecordsPerPage,
    getRedirectRecords,
};
